export function onChangeTabQueryParameterFromButtons(currentUrl) {
    

    let anchors = $(`a[href*="${currentUrl}?tab="]`);

    sessionStorage.setItem("tab", anchors);
    if (anchors) {
        anchors.click(function (event) {
            event.preventDefault();
            let href = sanitizeUrl($(this).attr("href"));
            let tabName = href.split("=")[1];
            $(`#${tabName}-tab`).click();
        });
    } 

}